let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fJQPR")).then(() => parcelRequire('4FRcU'));